// TODO - Checar o que pode ser usado a partir do DS (e testar inconsistências)

export const boolToYesNo = (value, accents) => {
	if (value === null || value === undefined) return
	if (accents) return value ? "Sim" : "Não"
	return value ? "sim" : "nao"
}

export const toDate = (value) => {
	if (!value) return ""

	const date = value.split("T").length ? value.split("T")[0] : value

	if (date.split("-").length > 1 && date.length === 10) {
		const instances = date.split("-")
		const [year, month, day] = instances
		const formattedDate = `${day}/${month}/${year}`
		if (formattedDate === "01/01/0001") return ""
		return formattedDate
	}

	return date
}

export const toCpf = (value) => {
	return value?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
}

export const toCnpj = (value) => {
	return value?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
}

export const toPhone = (value) => {
	if (!value) return
	if (value.length === 11) return toCellphone(value)
	if (value.length === 10) return toLandline(value)
	return value
}
const toCellphone = (value) => {
	if (!value) return
	return removeWhiteSpaces(value)?.replace(
		/(\d{2})(\d{5})(\d{4})/,
		"($1) $2-$3"
	)
}
const toLandline = (value) => {
	if (!value) return
	return removeWhiteSpaces(value)?.replace(
		/(\d{2})(\d{4})(\d{4})/,
		"($1) $2-$3"
	)
}

export const removeWhiteSpaces = (value) => value.replace(/\s+/g, "")

export const toCurrency = (value, options = {}) => {
	if (!value) return
	return numberFormatter({ value, style: "currency", ...options })
}

const numberFormatter = ({
	style = "decimal",
	value = 0,
	currency = "BRL",
	decimals = 2,
	currencyDisplay = "symbol"
}) => {
	if (!value) return
	return Intl.NumberFormat("pt-BR", {
		style,
		currency,
		currencyDisplay,
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals
	}).format(value)
}

export const toPostalCode = (value) =>
	value?.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3")

export const findValue = (_value, arr) => {
	if (!_value) return
	return arr.find((el) => el.key === _value).value
}

export const toIsoDate = (value) => {
	if (!value) return "0001-01-01T00:00:00.000Z"

	if (value.split("/").length > 1 && value.length === 10) {
		const instances = value.split("/")
		const [day, month, year] = instances

		return `${year}-${month}-${day}T00:00:00.000Z`
	}

	return value
}

export const yearsToMonths = (value) => Number(value) * 12

export const monthsToYears = (value) => value / 12

export const quantity = (value) => {
	return Number(value)
}

export const toTextMonths = (value) => {
	const sufix = value > 1 ? "meses" : "mês"
	return `${value} ${sufix}`
}

export const toTextYears = (value) => {
	const valueInYears = value / 12
	const sufix = valueInYears > 1 ? "anos" : "ano"
	return `${valueInYears} ${sufix}`
}

export const removeCharsExceptNumbers = (value) => value.replace(/[^0-9.]/g, "")

export const yesNoToBool = (value) => value === "sim"

export const currencyToFloat = (value) => {
	const previewValue = value.replace(/\.|\,/g, "")
	return Number(previewValue.replace(/(\d{1,})(\d{2})/, "$1.$2"))
}

export const floatToDisplayableNumber = (value) => {
	return Intl.NumberFormat("pt-BR", {
		style: "decimal",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(value)
}

export const sanitizeText = (value) =>
	value
		?.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]+/gim, "")
		.replace(/\s\s+/g, " ")
		.trim()

export const toPercent = (value) => `${value * 100}%`

export const selectLabelToValue = (label, options) => {
	const optionObject = options.find((option) => option.label === label)
	if (!optionObject) return ""
	return optionObject.value
}

export const selectValueToLabel = (value, options) => {
	const optionObject = options.find((option) => option.value === value)
	if (!optionObject) return ""
	return optionObject.label
}
